const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

// ---------- Scroll reveal ----------

document.documentElement.classList.add('reveal-ready');

const revealer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            entry.target.classList.add('is-visible');
            revealer.unobserve(entry.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px' }
      )
    : null;

function observeReveals(root = document) {
  $$('[data-reveal]:not(.is-visible)', root).forEach((el) => (revealer ? revealer.observe(el) : el.classList.add('is-visible')));
}

observeReveals();

// The theme editor re-renders sections in place, so reveal whatever it just inserted.
document.addEventListener('shopify:section:load', (event) => {
  observeReveals(event.target);
  setupBuy(event.target);
});

// ---------- Header ----------

const header = $('.site-header');
const updateHeader = () => header.classList.toggle('is-solid', window.scrollY > 24);
updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

// ---------- Buy section ----------

function setupBuy(root = document) {
  const form = $('[data-buy-form]', root);
  if (!form) return;

  const button = $('[data-buy-button]', form);
  if (button.disabled) return; // Sold out.

  const selected = () => $('input[name="quantity"]:checked', form);
  const updateButton = () => (button.textContent = `Buy now · ${selected().dataset.total}`);
  form.addEventListener('change', updateButton);

  // A cart permalink (/cart/<variant>:<quantity>) starts a fresh checkout with exactly this bag, so earlier
  // visits can't leave extra pairs in it. Without JS the form posts to /cart/add and goes on to checkout.
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    button.disabled = true;
    button.textContent = 'Taking you to checkout…';
    window.location.href = `${form.dataset.cartUrl}/${form.dataset.variantId}:${selected().value}`;
  });

  // Coming back from checkout with the browser's back button restores this page from cache, mid-redirect.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    button.disabled = false;
    updateButton();
  });

  const thumbs = $('[data-thumbs]', root);
  const mainImage = $('[data-main-image]', root);
  thumbs?.addEventListener('click', (event) => {
    const thumb = event.target.closest('.thumb');
    if (!thumb || thumb.getAttribute('aria-pressed') === 'true') return;
    // Drop the responsive srcset so the browser shows the picked photo, not a cached size of the first one.
    mainImage.removeAttribute('srcset');
    mainImage.src = thumb.dataset.src;
    mainImage.animate?.([{ opacity: 0 }, { opacity: 1 }], { duration: 350, easing: 'ease-out' });
    $$('.thumb', thumbs).forEach((t) => t.setAttribute('aria-pressed', String(t === thumb)));
  });
}

setupBuy();
